import React, { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getQuoteById } from "../redux/features/quickQuateSlice";

const SERVICE_COLORS = {
  commercial_cleaning: "#4F46E5",
  residential_cleaning: "#10B981",
  industrial_cleaning: "#F59E0B",
  specialized_cleaning: "#EF4444",
};

export default function QuoteDetails() {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { currentQuote, loading, error } = useSelector(
    (state) => state.quickQuote
  );

  useEffect(() => {
    if (id) {
      dispatch(getQuoteById(id));
    }
  }, [dispatch, id]);

  const formatServiceType = (type) => {
    return type
      ?.split("_")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="p-4 text-red-600 bg-red-50 rounded-lg">
        Error: {error}
      </div>
    );
  }

  return (
    <div className="max-w-3xl mx-auto p-6">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-3xl font-bold text-gray-900">Quote Details</h1>
        <button
          onClick={() => navigate(-1)}
          className="px-4 py-2 text-sm font-medium text-gray-600 hover:text-gray-900"
        >
          ← Back
        </button>
      </div>

      {currentQuote && (
        <div className="bg-white shadow rounded-lg overflow-hidden">
          <div className="p-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {/* Customer Information */}
              <div className="space-y-4">
                <h2 className="text-xl font-semibold text-gray-800">
                  Customer Information
                </h2>
                <div>
                  <label className="text-sm font-medium text-gray-500">
                    Name
                  </label>
                  <p className="mt-1 text-lg font-medium text-gray-900">
                    {currentQuote.name}
                  </p>
                </div>
                <div>
                  <label className="text-sm font-medium text-gray-500">
                    Email
                  </label>
                  <p className="mt-1 text-lg text-gray-900">
                    {currentQuote.email}
                  </p>
                </div>
                <div>
                  <label className="text-sm font-medium text-gray-500">
                    Phone
                  </label>
                  <p className="mt-1 text-lg text-gray-900">
                    {currentQuote.mobileNumber}
                  </p>
                </div>
              </div>

              {/* Service Information */}
              <div className="space-y-4">
                <h2 className="text-xl font-semibold text-gray-800">
                  Service Information
                </h2>
                <div>
                  <label className="text-sm font-medium text-gray-500">
                    Service Type
                  </label>
                  <span
                    className="mt-1 px-3 py-1 inline-flex text-sm font-semibold rounded-full"
                    style={{
                      backgroundColor: `${
                        SERVICE_COLORS[currentQuote.serviceType]
                      }20`,
                      color: SERVICE_COLORS[currentQuote.serviceType],
                    }}
                  >
                    {formatServiceType(currentQuote.serviceType)}
                  </span>
                </div>
                <div>
                  <label className="text-sm font-medium text-gray-500">
                    Description
                  </label>
                  <p className="mt-1 text-lg text-gray-900">
                    {currentQuote.description}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
